// extracted by mini-css-extract-plugin
module.exports = {"burgerButton":"HeaderBurgerButton_burgerButton__miF8v","lines":"HeaderBurgerButton_lines__56qfc"};